import telegramIcon from "../../../../src/images/telegram.svg";
import s7 from "../../../../src/images/s7.svg";
import myCar from "../../../../src/images/my_car.jpg";
import * as React from 'react';
export default {
  telegramIcon,
  s7,
  myCar,
  React
};